import { StoredFile } from '@dreryk/file-repository-api';

import { Base64, DocumentAsBase64, HtmlDocumentAsBase64 } from '@dreryk/react-common';

export type Printable = { data?: Base64 };

type MapPrintableToDocumentPdfReturnFn = DocumentAsBase64 | undefined;
export const mapPrintableToDocumentPdf = (printable: Printable | undefined): MapPrintableToDocumentPdfReturnFn => {
   return printable?.data ? { base64: printable.data } : undefined;
};

type MapPrintableToDocumentHtmlReturnFn = HtmlDocumentAsBase64 | undefined;
const mapPrintableToDocumentHtml = (printable: Printable): MapPrintableToDocumentHtmlReturnFn => {
   return printable.data ? { htmlBase64: printable.data } : undefined;
};

export const mapOtherPrintDocuments = (
   otherDocuments: StoredFile[]
): (MapPrintableToDocumentPdfReturnFn | MapPrintableToDocumentHtmlReturnFn)[] => {
   return otherDocuments.map((currentDocument) =>
      currentDocument.metadata.fileName.endsWith('.html')
         ? mapPrintableToDocumentHtml(currentDocument)
         : mapPrintableToDocumentPdf(currentDocument)
   );
};
